var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 4.6875C12.181 4.6875 9.89581 6.97271 9.89581 9.79167C9.89581 12.6106 12.181 14.8958 15 14.8958C17.8189 14.8958 20.1041 12.6106 20.1041 9.79167C20.1041 6.97271 17.8189 4.6875 15 4.6875ZM11.7708 9.79167C11.7708 8.00825 13.2166 6.5625 15 6.5625C16.7834 6.5625 18.2291 8.00825 18.2291 9.79167C18.2291 11.5751 16.7834 13.0208 15 13.0208C13.2166 13.0208 11.7708 11.5751 11.7708 9.79167Z",
    fill: "#121212"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8334 17.1875C9.4797 17.1875 8.18144 17.7253 7.22422 18.6825C6.26701 19.6397 5.72925 20.938 5.72925 22.2917V24.375C5.72925 24.8928 6.14898 25.3125 6.66675 25.3125C7.18451 25.3125 7.60425 24.8928 7.60425 24.375V22.2917C7.60425 21.4352 7.94446 20.6139 8.55005 20.0083C9.15564 19.4027 9.97699 19.0625 10.8334 19.0625H19.1667C20.0232 19.0625 20.8445 19.4027 21.4501 20.0083C22.0557 20.6139 22.3959 21.4352 22.3959 22.2917V24.375C22.3959 24.8928 22.8156 25.3125 23.3334 25.3125C23.8512 25.3125 24.2709 24.8928 24.2709 24.375V22.2917C24.2709 20.938 23.7332 19.6397 22.7759 18.6825C21.8187 17.7253 20.5205 17.1875 19.1667 17.1875H10.8334Z",
    fill: "#121212"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.3c25be6d8c0b78acd08bcb71e8d4e236.svg";
export { ForwardRef as ReactComponent };